import { useContext, useMemo } from 'react'
import { ScoreContext } from '../providers'

export function useScore(id: string) {
  const { scores, setScore } = useContext(ScoreContext)
  const setter = useMemo(() => (value: number) => setScore(id, value), [id])
  return [scores[id] ?? 0, setter] as const
}
